// extracted by mini-css-extract-plugin
module.exports = {"component":"styles__component--1N3Zh","input":"styles__input--30U1e"};